import ProfilesService from 'top20common/distribution/services/profiles';

export default {
  saveQuestionnaireAction(context, payload) {
    context.commit('mutateQuestionnaireFormLoadingState', true);
    return new Promise((resolve, reject) => {
      ProfilesService.updateProfileFromQuestionnaire(payload)
        .then(response => {
          resolve(response);
        })
        .catch(errors => {
          context.commit('mutateQuestionnaireFormErrorsState', errors.response.data.errors);
          reject(errors);
        })
        .finally(() => {
          context.commit('mutateQuestionnaireFormLoadingState', false);
        });
    });
  }
};
